import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import Typography from '@material-ui/core/Typography';
import ClientsTable from '../DashComponents/ClientsTable'
import { deleteMember } from '../../../../store/Actions/memberActions/memberActions'
import { Paper, Divider, Fab, Grid } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add';
import Modal from '@material-ui/core/Modal';
import AddClient from '../DashComponents/ClientComponents/AddClient'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles'

function getModalStyle() {
  const top = 50 ;
  const left = 50 ;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const styles = theme => ({
  paper: {
    position: 'absolute',
    //width: theme.spacing.unit * 50,
    width: '100%',
    maxWidth: '800px',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
    outline: 'none',
  },
});
class AllClients extends Component {
  state = {
    open: false,
};
handleOpen = () => {
    this.setState({ open: true });
};

handleClose = () => {
    this.setState({ open: false });
};
    deleteSelected = (memberId) => {
        let companyId = this.props.profile.id
        this.props.deleteMember( companyId, memberId)
    }

    render() {
      const { classes } = this.props;
      var companyId = sessionStorage.getItem('companyId')
      var buttonBg = sessionStorage.getItem('buttonBgColor')
      var buttonColor = sessionStorage.getItem('buttonColor') 

      if(!this.props.profile.company) return <Redirect to='/dashboard' />
    
        return (
          <div className="slideUp">

          <Typography component="h1" variant="h5">
          Clients
          </Typography>
          <Paper style={{padding: '24px', marginTop: '24px' }}>

          <Grid
            justify="space-between" // Add it here :)
            container 
            style={{marginBottom: '24px'}}
            spacing={24}
          >
              <Grid item>
                
              </Grid>
              <Grid item>
                    <Fab onClick={this.handleOpen} variant="extended"  aria-label="Add" style={{background: buttonBg, color: buttonColor }} >
                        <AddIcon />
                          Add Client
                      </Fab>
                </Grid>
          </Grid>

                  <Divider style={{marginBottom: '24px'}}/>
                  <ClientsTable companyId={this.props.profile.id} deleteSelected={this.deleteSelected} />

          </Paper>
          <Modal
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              open={this.state.open}
              onClose={this.handleClose}
              bodystyle={{overflow: 'auto', position: 'relative'}}
       
              >
              <div style={getModalStyle()} className={classes.paper}>
                  <Typography variant="h6" id="modal-title">
                  New Client Informations
                  </Typography>
                  <Typography variant="subtitle1" id="simple-modal-description">
                  Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
                  </Typography>

                  <AddClient buttonBg={buttonBg} buttonColor={buttonColor} companyId={companyId}/>
              </div> 
          </Modal>
          </div>
        )
    }
}

AllClients.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {

  return {
    profile: state.firebase.profile  
  }
}
export default withStyles(styles)(connect(mapStateToProps, {deleteMember}) (AllClients))